// Generated with util/create-component.js
import React from "react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";

import { ButtonProps } from "./Button.types";

import { StyledButton } from "./Button.styles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown as arrowDown, faChevronLeft as arrowLeft, faChevronRight as arrowRight, faChevronUp as arrowUp } from "@fortawesome/free-solid-svg-icons";

const Button: React.FC<ButtonProps> = ({
  children,
  label,
  state,
  theme,
  "gs-style": style = "solid",
  arrow,
  width,
  size,
  innerRef,
  className,
  variant,
  backgroundColor,
  textColor,
  borderColor,
  shadowColor,
  inverted,
  useSecondary,
  activeButton,
  link,
  href,
  ...nativeProps
}) => {
  if(link){
    return (
      <StyleSheetManager shouldForwardProp={isPropValid}>
        <StyledButton
        data-testid="Button"
        ref={innerRef}
        className={`button ${theme} ${size} ${style} ${state} ${width} arrow-${arrow} ${className || ""}`}
        disabled={state in ["disabled", "pending"]}
        {...nativeProps}
        theme={theme}
        variant={variant}
        backgroundColor={backgroundColor}
        textColor={textColor}
        borderColor={borderColor}
        shadowColor={shadowColor}
        inverted={inverted}
        useSecondary={useSecondary}
        activeButton={activeButton}
      
      >
        <a  href={href}>
        {arrow === "left" && <FontAwesomeIcon icon={arrowLeft} className={`arrow-left arrow`} size={"sm"} />}

        {children || label}
        {arrow === "right" && <FontAwesomeIcon icon={arrowRight} className={`arrow-right arrow`} size={"sm"} />}
        {arrow === "dropdown" && <FontAwesomeIcon icon={arrowDown} className={`arrow-dropdown arrow`} size={"sm"} />}
        {arrow === "up" && <FontAwesomeIcon icon={arrowUp} className={`arrow-up arrow`} size={"sm"} /> }
        </a>
      </StyledButton>
    </StyleSheetManager>
    )
  }
  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <StyledButton
        data-testid="Button"
        ref={innerRef}
        className={`button ${theme} ${size} ${style} ${state} ${width} arrow-${arrow} ${className || ""}`}
        disabled={state in ["disabled", "pending"]}
        {...nativeProps}
        theme={theme}
        variant={variant}
        backgroundColor={backgroundColor}
        textColor={textColor}
        borderColor={borderColor}
        shadowColor={shadowColor}
        inverted={inverted}
        useSecondary={useSecondary}
        activeButton={activeButton}
      >
        {arrow === "left" && <FontAwesomeIcon icon={arrowLeft} className={`arrow-left arrow`} size={"sm"} />}

        {children || label}
        {arrow === "right" && <FontAwesomeIcon icon={arrowRight} className={`arrow-right arrow`} size={"sm"} />}
        {arrow === "dropdown" && <FontAwesomeIcon icon={arrowDown} className={`arrow-dropdown arrow`} size={"sm"} />}
      </StyledButton>
    </StyleSheetManager>
  );
};

export default Button;
